import React from 'react'
import { Hero } from './Hero'
import { Webuild } from './Webuild'
import { StatsSection } from './StatsSection '
import { OurWork } from './OurWork'
import { OurSpace } from './OurSpace'

export const About = () => {
  return (
    <div>
        <Hero/>
        <Webuild />
        <StatsSection />
        <OurWork />
        <OurSpace />
    </div>
  )
}
